module.exports = __webpack_public_path__ + "5365ddf63736d0ce07b02e59ea21785a.svg";